import { render, staticRenderFns } from "./Relationships.vue?vue&type=template&id=070d8a31"
import script from "./Relationships.vue?vue&type=script&lang=js"
export * from "./Relationships.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports